<template>
    <div id="flashMessage" v-show="flashMessage != ''">
        <div id="flashMessageModalMask" v-show="flashMessage != ''" transition="fade" @click="closeMessage">
        </div>
        <div v-show="flashMessage != ''" id="flash-message" transition="fade">
            <div id="closeMessageDiv" @click="closeMessage">
                X
            </div>
            {{ flashMessage }}
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            closeMessage() {
                this.$store.commit('setMessageToGuest', '');
            }
        },
        computed: {
            flashMessage() {
                return this.$store.getters.getMessageToGuest;
            }
        }
    }
</script>

<style>
    #flashMessage {
        height: calc(100 * var(--vh));
        width: calc(100 * var(--vw));
        position: fixed;
        z-index: 20;
    }

    #flashMessageModalMask {
        background-color: black;
        opacity: .4;
        position: fixed;
        height: calc(100 * var(--vh));
        width: calc(100 * var(--vw));
        z-index: 20;
    }

    #flash-message {
        position: fixed;
        bottom: calc(50 * var(--vh));
        left: calc(40 * var(--vw));
        color: #333;
        width: calc(20 * var(--vw));
        min-height: calc(20 * var(--vh));
        padding: 15px;
        border-radius: calc(var(--vratio) * var(--vh));/*5px;*/
        background: linear-gradient(#DFDFDF, #FFFFFF);
        border: 2px solid #ccc;
        box-shadow: 1px 1px 5px #000;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 21;
    }

    .inmobile #flash-message {
        border-radius: 5px;
        height: calc(90 * var(--vh));
        width: calc(90 * var(--vw));
        top: calc(5 * var(--vh));
        left: calc(5 * var(--vw));
    }

    #closeMessageDiv {
        position: absolute;
        height: calc(4 * var(--vw));
        width: calc(4 * var(--vw));
        top: calc(1 * var(--vw));
        right: calc(1 * var(--vw));
        font-size: calc(1.8 * var(--vw));
        color: #7D7D7D;
        font-weight: bolder;
        cursor: pointer;
    }

    #closeGalleryDiv:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }
</style>
